import React from 'react';
import { View, Image, TouchableOpacity } from 'react-native'
import { Icon } from 'react-native-elements';
import sa from '../images/sa.png'
import manual from '../images/sa-off.png'
import moment from 'moment'
import { connect } from 'react-redux'
import TextZ from './TextZ';


const packageColor = (p, expired) => {
  return { color: expired ? 'red': (noPackage(p) ? '#aaaaaa' : 'gold') };
}

const packageName = (p) => {
  return noPackage(p) ? 'ไม่มีแพคเกจ' : 'VIP';
}

const noPackage = (p) => {
  switch(p.toUpperCase()) {
      case '': case null: case 'NONE':
      return true;
  }

  return false;
}

const expireDate = (e) => {
  
  const t = moment(e)
  if (t.year > 2100) {
      return 'ตลอดชีพ'
  }

  if (!e) {
    return 'กรุณาสมัคร VIP'
  }

  if (moment(e).isBefore(moment())) {
    return 'หมดอายุ'
  }

  return t.format('DD/MM/YYYY')
}

const Header = ({ onToggleSA, game_mode, onSetting, name, subscription_expire, subscription }) => {
    let image = manual
    if (game_mode === 'sa') {
        image = sa
    }

    const expired = moment(subscription_expire).isBefore(moment())

    return <View style={{ flexDirection:'row' }}>
        {onToggleSA ? <TouchableOpacity  onPress={onToggleSA}>
            <Image source={image} style={{width: 80, height: 32, marginRight: 10, cursor: 'pointer',}} />
        </TouchableOpacity> : null}
        <TouchableOpacity style={{ flexDirection:'column' }} onPress={onSetting} >
          <View style={{ flexDirection:'row' }}>
            <TextZ style={{ color: 'white', marginRight: 8 }}>{name}</TextZ>
            <TextZ style={{ ...packageColor(subscription), verticalAlign: 'middle' }}>
              [{packageName(subscription)}]
              </TextZ>
          </View>
          <TextZ style={{ ...packageColor(subscription, expired), verticalAlign: 'middle' }}>
            {expireDate(noPackage(subscription) ? null : subscription_expire)}
            <Icon name='settings' size={16} {...packageColor(subscription)}/>
          </TextZ>
        </TouchableOpacity>
      </View>
}


const mapStateToProps = state => {
    return { 
      game_mode: state.settings.game_mode, 
      name: state.auth.name,
      picture: state.auth.picture,
      subscription: state.auth.subscription,
      subscription_expire: state.auth.subscription_expire,
    };
};
const mapDispatchToProps = dispatch => {
    return {};
};
  
export default connect(mapStateToProps, mapDispatchToProps)(Header);